export default __webpack_public_path__ + "static/media/maleAvatar.2f2f26ec.jpg";